var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"policy-layout"},[_c('AppBar'),_vm._t("default"),_c('Footer',{staticStyle:{"flex":"0 0 auto"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }